import classNames from "classnames";
import React, { useEffect, useState } from "react";
import css from "./style.scss";
import { ReactSVG } from 'react-svg';
import userImg from 'assets/images/account-page/user-icon-lg.png';
import downFullArrow from '../../../assets/images/account-page/down-full-arrow.svg'
import downArrow from '../../../assets/images/account-page/down-arrow.svg';
import visaCard from '../../../assets/images/account-page/visa-card.svg';
import payFailedIcon from '../../../assets/images/exclamation.svg'

import CreditCardDropdown from '../components/CreditCardDropdown';
import { useFormContext as useCustomFormContext } from "../../../context/FormContext";
import { useFormContext as useRHFormContext } from "react-hook-form";
import { formatToLongDate, numberOfDaysFromToday } from "../../../utils/date/formatDate";
import { selectSelectedTeamMember ,selectShowFinishBuildingYourTeam , selectIsPaidUser , selectCardList , selectPlanMrcByPin , selectPlanTypesByUserType , selectBillingDashboard , selectNextBillingCycleDate, selectRemainingCycleDays } from "data/user/selectors";
import { useSelector } from "react-redux";
import { getFullDataURL } from "./validationSchemas";
import AccountLogo from "../components/AccountLogo";

const ReviewTeam = (props) => {


    const teamMember = useSelector(selectSelectedTeamMember).toJS();

    const dashboardBilling = useSelector(selectBillingDashboard)

    const cardList = useSelector(selectCardList);
    const showFinishBuildingYourTeam = useSelector(selectShowFinishBuildingYourTeam); // true user not fill with reloaded full 
    const { setValue, watch } = useRHFormContext();
    const selectedTier = watch("type");
    const { formData , updateFormData , onUpdateValidationSchema } = useCustomFormContext();

    const [imageUrl, setImageUrl] = useState(formData?.profilePicture ? formData?.profilePicture : null);

    const isPaidUser = useSelector(selectIsPaidUser)
    const RemainingCycleDays = useSelector(selectRemainingCycleDays);
    const nextBillingCycleDate = useSelector(selectNextBillingCycleDate);
    const planMrc = useSelector(selectPlanTypesByUserType(props?.review ? 'TEAM_FULL' : formData?.type,isPaidUser))
    
    // type will come for create team member flow 
    // userType will come from upgrade flow
    const [scoutUser, setScoutUser] = useState(() => {
        if (formData?.type === "SCOUT") return true;
        if (props?.review && formData?.userType === "SCOUT") {
          return false;
        }
        return formData?.userType === "SCOUT";
      });

    useEffect(() => {
        setValue('planMrcId', planMrc?.id);
        setValue('planMrc', planMrc);
    }, [planMrc])
    
    const handleConfirmChanges = () => {
        setValue('agreeToTerms', true); // Update state
      };


      useEffect(() => {
        const handleBeforeUnload = (e) => {
          e.preventDefault();
          e.returnValue = "You have unsaved changes. Are you sure you want to refresh?"; 
          return ""
        };
    
        window.addEventListener("beforeunload", handleBeforeUnload);
    
        return () => {
          window.removeEventListener("beforeunload", handleBeforeUnload);
        };
      }, []);  

      const handleCardChange = (selectedOption) => {
        // setSelectedCard(selectedOption);
        setValue('paymentMethodId', selectedOption?.paymentMethodId);
        setValue('selectedPayment', selectedOption);
        console.log("Selected Card:", selectedOption);
      };


    return (

        <div className="container">
            <div className={css.clsTMReviewPaySec}>
                <div className="row justify-content-center">
                    <div className="col-lg-4">
                        <div className={css.clsTMReviewPayCard}>
                            <div className={css.clsTMReviewUserDetils}>
                                <div className="d-flex align-items-center">
                                    <div className={css.clsTMReviewUserImg}>
                                        {imageUrl ? (
                                            <img src={getFullDataURL(imageUrl)} alt="Profile" />
                                        ) : (
                                            <img src={userImg} alt="Profile" />
                                        )}
                                    </div>
                                    <h5 className={css.clsTMReviewUserName}>{formData?.firstName} {formData?.lastName}</h5>
                                </div>
                            </div>                       
                        {props?.review ? (
                             <>
                            <div className={css.clsTMReviewTier}>
                                <h4 className={css.clsTxtLine1}>MEMBER TIER</h4>
                                <h4 className={css.clsTxtLine2}>{'Scout'}</h4>
                            </div>
                                <div className="text-center">
                                <ReactSVG src={downFullArrow} className={classNames(css.mb_16, css.mt_16)} />
                            </div>
                            <div className={css.clsTMReviewTier}>
                                <h4 className={css.clsTxtLine1}>MEMBER TIER</h4>
                                <h4 className={css.clsTxtLine2}>{'Full Access'}</h4>
                                </div>
                            </>
                            ) : (
                            <div className={css.clsTMReviewTier}>
                                <h4 className={css.clsTxtLine1}>MEMBER TIER</h4>
                                <h4 className={css.clsTxtLine2}>{scoutUser ? 'Scout' : 'Full Access'}</h4>
                            </div>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className={css.clsTMReviewPayCard2}>
                            <h3 className={css.clsTMReviewHeading}>
                                <AccountLogo/>
                            Review And Confirm Changes</h3>

                            {(!scoutUser && isPaidUser) && (
                                <>
                                    <div className={css.clsTMReviewPayTimelineContainer}>
                                        <div className={css.clsTMReviewPayTimeline}>
                                            <div className={css.clsTMTimelineItem}>
                                                <div className={css.clsTMTimelineDot}></div>
                                                <div className={css.clsTMTimelineContent}>
                                                    <div className={css.clsTMTimelineHead}>
                                                        <h4 className={css.clsTMTimelineLabel}>Today</h4>
                                                        <h5 className={css.clsTMTimelinePrice}>${planMrc?.prorateAmount} </h5>
                                                    </div>
                                                    <p className={css.clsTMTimelineDescription}>Team Member gains full access, {RemainingCycleDays} days until next billing cycle.</p>
                                                </div>
                                            </div>

                                            <div className={css.clsTMTimelineLine}></div>

                                            <div className={css.clsTMTimelineItem}>
                                                <div className={css.clsTMTimelineDot}></div>
                                                <div className={classNames(css.clsTMTimelineContent,css.clsTMTimelineContentHeight)}>
                                                    <div className={css.clsTMTimelineHead}>
                                                        <h4 className={css.clsTMTimelineLabel}>Starting {formatToLongDate(nextBillingCycleDate)}</h4>
                                                        <h5 className={css.clsTMTimelinePrice}>$30/month</h5>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className={css.pb_48}>
                                        <div className={css.clsTMReviewPMCard}>
                                            <h4 className={css.clsTMReviewPMCardHeading}>Payment Method</h4>

                                            <CreditCardDropdown
                                                                        tag={false}
                                                                        paymentMethodType={'Subscription'}
                                                                        options={cardList}
                                                                        onChange={handleCardChange}
                                                                    />
                                        </div>
                                    </div>
                            {/* for payment Failed case */}
                            {/* <>
                                <div className={css.failedPay}>
                                    <div className={css.failedPay_Inner}>
                                        <img src={payFailedIcon} />
                                        <span>Payment Failed</span>
                                    </div>
                                    <p>There was an issue with your payment. Please choose a different payment method and try again.</p>
                                </div>

                                <p className={css.clsParagraph}>Have a Question? <span className={css.text_primary}>Contact Support</span></p>
                            </> */}
                            </> )}
                            <div className={`${css.clsTMReviewContentPara} ${!(!scoutUser && isPaidUser) ? css.mt_16 : ""}`}>
                            {(!scoutUser && isPaidUser) && (
                                <p className={classNames(css.clsPara, css.mb_16)}>
                                    <span className={css.text_b}>Starting on {formatToLongDate(nextBillingCycleDate)} you’ll be charged $30.00 automatically every month until you cancel.</span> This does not include any other PropStream services you may be subscribed to. Your price may change as described in the <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.text_primary}>PropStream Terms and Conditions.</a>
                                </p>
                            )}
                                <p className={css.clsPara}>
                                    By clicking “Confirm Changes” you agree to the <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.text_primary}>PropStream Terms and Conditions.</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReviewTeam;
